var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
export function getTosStatus() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get('/api/v1/ai/tos/status');
        return response.data;
    });
}
export function acceptTos() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.post('/api/v1/ai/tos/accept');
        return response.data;
    });
}
